module.exports = __webpack_public_path__ + "img/potential-events_nba-all-star.5460be0f.jpg";